const Ajax          = require('./Ajax');
const Axios         = require('axios');

class AjaxPull {

    constructor(host, query) {
        this.query    = query ? Object.assign({}, query) : {};

        this.pull     = [];
        this.instance = undefined;
        this.isLoad   = false;

        this.instance = Axios.create({
            baseURL         : host,
            timeout         : 30000,
            withCredentials : true,
            responseType    : 'json',
        });
    }

    _nextLoad() {
        if (this.pull.length === 0){
            this.isLoad = false;
            return;
        }
        let ajax = this.pull.shift();
        let conf = ajax.getConfig();
        console.log('conf pull ajax', conf);
        if (conf.onBeforeRequest) conf.onBeforeRequest(conf);
        this.instance.request(conf)
            .then((response) =>{
                ajax.call('onBeforeSuccess', response);
                ajax.call('onSuccess', response);
                ajax.call('onAfterSuccess', response);
                this._nextLoad()
            })
            .catch((error) => {
                if (error.response && ajax.isTry()) {
                    if (conf.priority === "high"){
                        this.pull.unshift(ajax);
                    } else {
                        this.pull.push(ajax);
                    }
                } else {
                    ajax.call('onFail', error);
                }
                this._nextLoad();
            })
            .finally(()=>{
                ajax.call('onFinal')
            });
    }

    request(url, config) {
        if (typeof url != "object") {
            url = {url:url};
        }
        let path = url.uri;
        delete url.uri;

        url = Object.assign(this.query, url);

        let tem = [];
        for (let k in url){
            if (k !== "type_content"
                 && !url[k] && url[k] !== 0
            ) continue;
            tem.push(encodeURIComponent(k) + "=" + encodeURIComponent(url[k]))
        }

        config.url = path + "?" + tem.join('&');

        // if (!config.headers){
        //     config.headers = {
        //         'X-Requested-With': 'XMLHttpRequest'
        //     };
        // } else {
        //     config.headers['X-Requested-With'] = 'XMLHttpRequest'
        // }

        //------------------------------------------------------
        let ajax = new Ajax(config);
        this.pull.push(ajax);

        if (!this.isLoad) {
            this.isLoad = true;
            setTimeout(()=>{
                this._nextLoad()
            }, 50)
        }
        return ajax;
    }

    get(url, config) {
        if (!config) {
            config = {}
        }
        config.method = 'get';

        return this.request(url, config)
    }

    post(url, data, config) {
        if (!config) {
            config = {}
        }
        config.method = 'post';
        config.data   = data;

        return this.request(url, config)
    }

}

module.exports = AjaxPull;